import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import makeStyles from '@mui/styles/makeStyles';
import format from 'date-fns/format';
import isPast from 'date-fns/isPast';
import orderBy from 'lodash/orderBy';
import React from 'react';
import { EventAgendaData } from '../types';
import { DisplayMarkup } from './display-markup';

const useStyles = makeStyles({
  agendaTabs: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #eaeaea',
  },
  agendaItem: {
    backgroundColor: '#fff',
    padding: 10,
    borderBottom: '1px solid #eaeaea',
  },
});

export function EventAgenda(props: { data: EventAgendaData[] }) {
  // Props
  const { data } = props;
  // State
  const [selectedDay, setSelectedDay] = React.useState<string | null>(null);
  // Hooks
  const classes = useStyles();

  const items = React.useMemo(() => orderBy(data, 'DateTime'), [data]);

  // Unique days present in the agenda, in chronological order
  const days = React.useMemo(
    () =>
      items
        .map((item) => item.DateTime?.substring(0, 10) || '')
        .filter((day, index, all) => day !== '' && day !== all[index - 1]),
    [items],
  );

  // Fall back to today, then to the first day of the event
  const today = format(new Date(), 'yyyy-MM-dd');
  const activeDay =
    selectedDay && days.includes(selectedDay)
      ? selectedDay
      : days.includes(today)
        ? today
        : days[0];

  const handleChange = (event: React.SyntheticEvent, newDay: string) => {
    setSelectedDay(newDay);
  };

  // Get the agenda items for the selected day
  const dayItems = items.filter(
    (item) => (item.DateTime?.substring(0, 10) || '') === activeDay,
  );

  return (
    <div>
      <div className={classes.agendaTabs}>
        <Tabs
          indicatorColor="secondary"
          textColor="secondary"
          variant="scrollable"
          scrollButtons
          value={activeDay ?? false}
          onChange={handleChange}
          allowScrollButtonsMobile
        >
          {days.map((day) => {
            const label = format(new Date(day + 'T00:00'), 'EEE MMM dd');
            return <Tab key={day} value={day} label={label} />;
          })}
        </Tabs>
      </div>

      <div>
        {dayItems.map((item) => {
          const itemEnded = item.DateTime
            ? isPast(new Date(item.DateTime))
            : true;

          return (
            <div
              key={item.AgendaId}
              className={classes.agendaItem}
              style={{ opacity: itemEnded ? 0.6 : 1 }}
            >
              <div>
                <strong style={{ fontSize: 16 }}>
                  {item.DateTime ? format(new Date(item.DateTime), 'p') : null}{' '}
                  - {item.Title}
                </strong>
                <DisplayMarkup markup={item.Description} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
